import { AppError } from "../../../shared/utils/error-handler";
import type { OrderRecognitionRuleRepository } from "../../repositories/company/order-recognition-rule-repository";
import type {
  OrderRecognitionRule,
  CustomerEmailItem,
  CustomerSuggestion,
  SaveOrderRecognitionRuleRequest,
  AddCustomerEmailRequest,
} from "../../types/order-recognition-rule";

export class OrderRecognitionRuleUsecase {
  constructor(
    private orderRecognitionRuleRepository: OrderRecognitionRuleRepository,
  ) {}

  async getRule(companyId: number): Promise<OrderRecognitionRule> {
    try {
      return await this.orderRecognitionRuleRepository.getRule(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "주문 인식 규칙을 불러오지 못했습니다.",
        "ORDER_RECOGNITION_RULE_GET_FAILED",
        error,
      );
    }
  }

  async saveRule(
    companyId: number,
    request: SaveOrderRecognitionRuleRequest,
  ): Promise<OrderRecognitionRule> {
    try {
      return await this.orderRecognitionRuleRepository.saveRule(
        companyId,
        request,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "주문 인식 규칙 저장에 실패했습니다.",
        "ORDER_RECOGNITION_RULE_SAVE_FAILED",
        error,
      );
    }
  }

  async getCustomerEmails(companyId: number): Promise<CustomerEmailItem[]> {
    try {
      return await this.orderRecognitionRuleRepository.getCustomerEmails(
        companyId,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "등록 고객 메일을 불러오지 못했습니다.",
        "CUSTOMER_EMAILS_GET_FAILED",
        error,
      );
    }
  }

  async addCustomerEmail(
    companyId: number,
    request: AddCustomerEmailRequest,
  ): Promise<CustomerEmailItem> {
    try {
      return await this.orderRecognitionRuleRepository.addCustomerEmail(
        companyId,
        request,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "등록 고객 메일 추가에 실패했습니다.",
        "CUSTOMER_EMAIL_ADD_FAILED",
        error,
      );
    }
  }

  async deleteCustomerEmail(companyId: number, id: number): Promise<void> {
    try {
      return await this.orderRecognitionRuleRepository.deleteCustomerEmail(
        companyId,
        id,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "등록 고객 메일 삭제에 실패했습니다.",
        "CUSTOMER_EMAIL_DELETE_FAILED",
        error,
      );
    }
  }

  async suggestCustomerEmails(
    companyId: number,
    email: string,
  ): Promise<CustomerSuggestion[]> {
    try {
      return await this.orderRecognitionRuleRepository.suggestCustomerEmails(
        companyId,
        email,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "이메일 추천을 불러오지 못했습니다.",
        "CUSTOMER_EMAIL_SUGGEST_FAILED",
        error,
      );
    }
  }
}
